export default {
  init() {
    $('.header .main-menu__item > a[data-image]').each(function() {
      $(this).closest('.main-menu__item').append('<div class="main-menu__item__media"><img alt="" src="' + $(this).attr('data-image') + '"/></div>')
    })

    // Language
    var $languageItem = $('<li class="quick-icons__item quick-icons__item--language">' +
    '<a href="#" class="quick-icons__link btn-icon--language btn-icon-only btn-icon">' + dayalabs_l10n.CHOOSE_REGION + '</a>' +
    '<ul class="quick-icons__submenu"></ul>' +
    '</li>');

    $('.quick-icons__item.--wpml').appendTo($languageItem.find('.quick-icons__submenu'));

    $languageItem.find('.wpml-ls-native[lang="en-us"]').html('USA (En<span>glish</span>)');
    $languageItem.find('.wpml-ls-native[lang="en-ca"]').html('Canada (En<span>glish</span>)');
    $languageItem.find('.wpml-ls-native[lang="fr-ca"]').html('Canada (Fr<span>ançais</span>)');
    $('.quick-icons').prepend($languageItem);

    var lang_code = $('html').attr('lang')
    $languageItem.find('.wpml-ls-native[lang="' + lang_code + '"]').closest('li').addClass('--selected')

    $('.quick-icons > li > a').wrapInner('<span></span>');
    $('.quick-icons > li > a').click(function() {
      $(this).closest('li').toggleClass('--open')
      if ($(event.target).closest('.quick-icons__item--js-search').length == 0) {
        $('.quick-icons__item--js-search').removeClass('--open')
      }
      return false;
    })

    $('.header__main-menu').click(function(event) {
      if ($(event.target).closest('.quick-icons__item--language').length == 0) {
        $('.quick-icons__item--language').removeClass('--open')
      }
      if ($(event.target).closest('.quick-icons__item--js-search').length == 0) {
        $('.quick-icons__item--js-search').removeClass('--open')
      }
    })

    // Search
    $('footer + .search-form__container').appendTo('.quick-icons__item--js-search')
    $('.js-search').click(function() {
      $('.header .search-form__container .search-form__input').focus().select()
      $('.quick-icons__item--language').removeClass('--open')
    })

    $('.main-menu .main-menu__item--parent').each(function() {
      $(this).Drawer({
        toggle: '.main-menu__link',
        content: '.main-menu__sub-menu--1'
      })
      var link = $(this).find('.drawer__toggle:not([href=#])[href]').clone()
      $(this).find('.drawer__toggle:not([href=#])[href]').attr('href', '');
      link.html('<i class="icon-right-2"></i>')
      link.removeClass('main-menu__link').addClass('main-menu__mobile-link')
      $(this).prepend(link)
    })

    $('.header__secondary-menu').clone().appendTo('.header__main-menu__blocks')

    // Top bar
    $(window).on('load orientationchange resize scroll message_dismissed', topBarHeight)
    topBarHeight()

    function topBarHeight() {
      let $topBar = $('.featured-message--style-top-bar'),
      $menuBar = $('.header__main'),
      topBarHeight = 0,
      menuBarHeight = 0,
      headerHeight = 0
      if ($topBar.length && $topBar.is(':visible')) {
        topBarHeight = $topBar.outerHeight(false)
      }
      if ($menuBar.length && $menuBar.is(':visible')) {
        menuBarHeight = $menuBar.outerHeight(false)
      }
      headerHeight = menuBarHeight
      if (topBarHeight && !$('body').hasClass('header--scroll-down') && !$('body').hasClass('--menu-open')) {
        headerHeight += topBarHeight
      }
      $('.app').css({
        '--top-bar-height': topBarHeight + 'px',
        '--menu-height': menuBarHeight + 'px',
        '--header-height': headerHeight + 'px',
      })
    }

    function shrinkHeader() {
      $('.header').removeClass('--shrink');
      if ($(window).height() - $('.header__main-menu__blocks').outerHeight() < 40){
        $('.header').addClass('--shrink');
      }
      $('.main-menu').css('--media-height', $('.main-menu').outerHeight() + 'px');
    }

    $('.main-menu').css('--count', $('.main-menu .main-menu__item').length);
    $(window).on('load orientationchange resize', shrinkHeader)

    $('.header__main-menu').click(function(event) {
      if ($(event.target).closest('.header__cta, .main-menu, .header__secondary-menu, .quick-icons').length == 0) {
        $('.header__burger').click()
      }
    })
  }
}
